import { createFileRoute, Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { default as Vehicle } from "@/assets/illustrations/vehicle.svg"
import Card from "@/globalComponents/atoms/Card"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"

export const Route = createFileRoute(
  "/qr/$qrLookupID/reserve/$epoch/payment-complete"
)({
  staticData: {
    pageName: "Payment Complete",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { qrLookupID } = Route.useParams()
  const { t } = useTranslation(["reserve", "common"])

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card>
        <Vehicle />
        <Heading className="center" level={1} as={1}>
          {t("paymentComplete.header")}
        </Heading>
        <Text
          className="center"
          level={1}
          style={{ marginTop: "var(--space-3)" }}
        >
          {t("paymentComplete.copy")}
        </Text>
      </Card>
      <Text style={{ marginTop: "var(--space-5)" }} className="center">
        <Link to="/qr/$qrLookupID/welcome" params={{ qrLookupID }}>
          {t("common.returnToMenu", { ns: "common" })}
        </Link>
      </Text>
    </div>
  )
}
